/**
 * Builds a CSS `url("…")` value from an asset URL. The URL is escaped as a CSS
 * string, so it stays valid whatever the bundler emits for the asset: Vite
 * hands back a path or a quote-escaped data URL, but other bundlers inline
 * SVGs as `data:image/svg+xml,<svg width="24" …>` with raw double quotes, which
 * would end a naively quoted `url("…")` early and drop the whole declaration.
 */
export function cssUrl(url: string): string {
  const escaped = url
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"')
    .replace(/\r?\n/g, "\\a ");
  return `url("${escaped}")`;
}
